import {ReactNode, useEffect} from 'react'
import {useNavigate} from "react-router-dom";

import {FloatingChat} from '@components/FloatingChat'
import {SidePanel} from "@components/layout/SidePanel";
import {ChatProvider} from "@contexts/ChatContext";
import {useUser} from "@hooks/use-user";
import {cn} from "@lib/utils.ts";

interface LayoutProps {
    children: ReactNode
}

export function AuthenticatedLayout({children}: LayoutProps) {
    const {isAuthenticated, loading} = useUser();
    const navigate = useNavigate();

    useEffect(() => {
        if (!loading && !isAuthenticated) {
            navigate('/login');
        }
    }, [isAuthenticated, loading, navigate]);

    if (loading) {
        return (
            <div className={cn("flex flex-col gap-6 items-center justify-center min-h-96")}>
                <div className="text-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
                    <p className="text-muted-foreground">Loading...</p>
                </div>
            </div>
        );
    }

    return (
        <ChatProvider>
            <div className="h-screen antialiased bg-[#F8FAFC] flex flex-row overflow-hidden font-inter">
                {/* Left: expandable chat side panel */}
                <SidePanel />

                {/* Right: Top bar + content (rendered by children / WorkspacePage) */}
                <main className="flex-1 min-w-0 flex flex-col overflow-hidden">
                    {children}
                </main>

                {/* Floating chat (only renders when undocked) */}
                <FloatingChat />
            </div>
        </ChatProvider>
    )
}
